import './App.css';
import { Stage } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { useLayoutEffect, useRef } from 'react';
// RU: ядро — как пакет: в монорепо алиас webpack (webpack.config.js) подменяет его исходниками
//     libs/slots-core, в репо игры это сам npm-пакет. Код игры от этого не зависит.
import { Frame } from 'pascal-slots-core';
import { ErrorBoundary } from './components/errorBoundary';
import { isMobile } from './helpers/isMobile';
import { GameModule } from './gameModule';
import { parseQuery } from './helpers/parseQuery';
import { gameControlService } from './gameModule/services/gameControlService';
import { configuratedStage } from './helpers/configuratedStage';
import { stageOptions } from './constants/gameConstants';
import { gameConfigurationStore } from './gameModule/store/gameConfigurationStore';

export const App = observer(() => {
  const refApp = useRef(null);
  const query = parseQuery(window.location.search);
  const { gameConfigurationisReady, gameConfiguration, createGameConfigurationTree } = gameConfigurationStore;

  useLayoutEffect(() => {
    configuratedStage(refApp);
    createGameConfigurationTree(query);
  }, []);

  // RU: ErrorBoundary — ВНУТРИ <Stage>: снаружи брошенный рендер разбирает React-root целиком, а
  //     @pixi/react на этом делает app.destroy() — чёрный канвас вместо одного внятного лога.
  return (
    <div className={isMobile() ? 'canvas-wrapper' : 'canvas-web-wrapper'}>
      <Stage
        ref={refApp}
        width={isMobile() ? window.innerWidth : 1440}
        height={isMobile() ? window.innerHeight : 810}
        options={stageOptions}>
        {gameConfigurationisReady && (
          <ErrorBoundary name='GameTree'>
            <Frame queryParams={query} gameConfig={gameConfiguration} gameControlService={gameControlService}>
              <GameModule />
            </Frame>
          </ErrorBoundary>
        )}
      </Stage>
    </div>
  );
});
